document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.ugc-video-slider');
  var perView = parseInt(container.dataset.perView, 10) || 3;

  var glide = new Glide(container, {
    type: 'carousel',
    perView: perView,
    focusAt: 'center',
    autoplay: 3000,
    hoverpause: true,
    gap: 20,
    peek: { before: 0, after: 0 }
  }).mount();

  glide.on('run.after', function () {
    var slides = container.querySelectorAll('.glide__slide');
    slides.forEach(function (slide, idx) {
      var video = slide.querySelector('video');
      var isCenter = idx === glide.index;

      slide.classList.toggle('is-centered', isCenter);

      if (isCenter && !video.src) {
        video.src = video.dataset.src;
        video.load();
      }
    });
  });

  container.querySelectorAll('video').forEach(function (video) {
    video.addEventListener('click', function () {
      video.muted = false;
      video.play();
    });
  });

  container.querySelectorAll('.expand-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var vid = e.currentTarget.previousElementSibling;
      if (vid.requestFullscreen) vid.requestFullscreen();
    });
  });
});
